var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../../../opt/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader?{\"sourceMap\":false}!css-loader?{\"sourceMap\":false,\"minimize\":true,\"importLoaders\":1,\"alias\":{\"/assets\":\"/app/assets\",\"/static\":\"/app/static\"}}!../../../../opt/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3226c00c\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader?{\"sourceMap\":false}!../../../../opt/node_modules/vue-loader/lib/selector?type=styles&index=0!./Content.vue")
}
var normalizeComponent = require("!../../../../opt/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!ts-loader?{\"appendTsSuffixTo\":[{}],\"transpileOnly\":true}!../../../../opt/node_modules/vue-loader/lib/selector?type=script&index=0!./Content.vue"
import __vue_script__ from "!!ts-loader?{\"appendTsSuffixTo\":[{}],\"transpileOnly\":true}!../../../../opt/node_modules/vue-loader/lib/selector?type=script&index=0!./Content.vue"
/* template */
import __vue_template__ from "!!../../../../opt/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3226c00c\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"object\":\"src\",\"embed\":\"src\"},\"preserveWhitespace\":false,\"buble\":{\"transforms\":{}}}!../../../../opt/node_modules/vue-loader/lib/selector?type=template&index=0!./Content.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3226c00c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "components/services/marketing/Content.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3226c00c", Component.options)
  } else {
    hotAPI.reload("data-v-3226c00c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./components/services/marketing/Content.vue
// module id = N4We
// module chunks = 10